export default __webpack_public_path__ + "static/media/gl_6.2ed66d2f.mp3";